import { render, staticRenderFns } from "./textImagesList.vue?vue&type=template&id=c87e6990&scoped=true"
import script from "./textImagesList.vue?vue&type=script&lang=js"
export * from "./textImagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87e6990",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/vercel/path0/components/elements/Picture.vue').default,Richtext: require('/vercel/path0/components/elements/Richtext.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
